<template>

  <b-modal :id="menuPosition.value" :ref="menuPosition.value" centered scrollable hide-header-close
           modal-class="menus-modal" @ok="onSubmitChange">
    <template #modal-header="{ cancel }">
      <menu-modal-header icon="arrow-left-right" title="منو مورد نظر را انتخاب کنید"
                         :subtitle="`جایگاه: ${menuPosition.text}`" @close="cancel()"/>
    </template>

    <form @submit.stop.prevent="onSubmitChange">
      <div class="menus-modal-field">
        <label>جایگاه</label>
        <b-form-input type="text" class="text-left" dir="ltr" v-model="selectMenu.position" readonly/>
        <small class="menus-modal-help">منوی انتخاب‌شده جایگزین منوی فعلی این جایگاه می‌شود.</small>
      </div>

      <form-group :validations="$v.selectMenu.menu_id">
        <div slot-scope="{ errors, invalid }" class="menus-modal-field">
          <label>منو</label>
          <b-form-select type="color" v-model="selectMenu.menu_id" :options="selectOptions"/>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>
    </form>

    <template #modal-footer="{ ok, cancel }">
      <div class="menus-modal-actions">
        <button type="button" class="menus-btn is-primary" @click="ok()">
          <b-icon icon="check2"></b-icon>
          <span>ثبت تغییر</span>
        </button>
        <button type="button" class="menus-btn" @click="cancel()">انصراف</button>
      </div>
    </template>
  </b-modal>

</template>

<script>
import FormGroup from "../../validator/FormGroup";
import {required, minLength, maxLength, numeric} from "vuelidate/lib/validators";
import FormErrorsManager from '../../validator/FormErrorsManager.vue'
import MenuModalHeader from './MenuModalHeader.vue'

export default {
  name: "ChangeMenuModalForm",
  components: {MenuModalHeader, FormGroup, FormErrorsManager},
  props:['menuPosition', 'selectMenu', 'selectOptions','menus'],
  data() {
    return {
      menuPositions: [
        {text:'منو اصلی فروشگاه', value:'store_nav'},
        {text:'منو فوتر سایت', value:'store_footer'},
        {text:'منو اصلی وبلاگ', value:'blog_nav'},
        {text:'منو فوتر وبلاگ', value:'blog_footer'} ],
    }
  },
  validations: {
    selectMenu: {
      menu_id: {required}
    },
  },
  methods: {
    changeMenu() {
      let menu = {}
      let currentMenu = this.getCurrentActiveItem(this.selectMenu.position)

      this.menus.forEach(element => (element.id === this.selectMenu.menu_id) ? menu = element : null)
      menu.position = this.selectMenu.position
      menu.status = 1
      menu.menu_id = menu.id

      if (currentMenu !== null) {
        this.$store.dispatch("Menu/updateMenu", currentMenu).then(res => {
          this.$store.dispatch("Menu/updateMenu", menu)
        })
      } else {
        this.$store.dispatch("Menu/updateMenu", menu)
      }

    },
    getCurrentActiveItem(position) {
      let currentMenu = null
      this.menus.forEach(element => (element.position === position && element.status === 1) ? currentMenu = element : null)
      if (currentMenu !== null) {
        delete currentMenu.position
        currentMenu.status = 0
        currentMenu.menu_id = currentMenu.id
      }
      return currentMenu
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmitChange(bvModalEvent){
      bvModalEvent.preventDefault()
      if (this.invalid()) {
        const form = this.selectMenu
        this.changeMenu()
        this.$nextTick(() => {
          this.$bvModal.hide(this.selectMenu.position)
        })
      }
    }
  },
}
</script>
